// TODO: Create a component for different button/Link variants.
import { cx, cva, type VariantProps } from 'cva';
import Link from 'next/link';

interface LinkButtonProps extends VariantProps<typeof button> {
  children: React.ReactNode;
  icon?: boolean;
  href: string;
}

const button = cva({
  base: [
    'inline-flex group relative isolate w-fit transform-gpu overflow-hidden rounded-md px-3 py-[0.1875rem] cursor-pointer',
    'after:absolute after:inset-0 after:hover:opacity-100',
    'transition duration-300 ease-[cubic-bezier(.4,.36,0,1)] after:duration-300 after:ease-[cubic-bezier(.4,.36,0,1)] after:transtion-opacity' // Animation
  ],
  variants: {
    intent: {
      primary: [
        'shadow-[inset_0px_1px_0px_theme(colors.white/12%),inset_0px_-1px_0px_theme(colors.white/4%),0px_2px_2px_-1px_rgb(66,67,77,0.24),0px_4px_4px_-2px_rgb(66,67,77,0.12)] bg-newGray-900 ring-1 ring-newGray-950',
        'after:bg-[linear-gradient(theme(colors.white/24%),theme(colors.white/16%)_46%,theme(colors.white/12%)_54%,theme(colors.white/8%))] after:opacity-60',
        '[--text-color:#FFFFFF]'
      ],
      skyBlue: [
        'bg-[#38D3FD] [--text-color:#043048] [--text-drop-shadow:0px_1px_0px_theme(colors.white/24%)] shadow-[inset_0px_1px_0px_theme(colors.white/26%)] ring-[#60BEF1] ring-1',
        'after:bg-[linear-gradient(theme(colors.white/24%),theme(colors.white/24%)_46%,theme(colors.white/12%)_54%,theme(colors.white/8%))]'
      ]
    }
  }
});

export function LinkButton({
  children,
  intent = 'primary',
  icon,
  href
}: LinkButtonProps) {
  return (
    <Link className={button({ intent })} href={href}>
      <span className="relative z-10 flex items-center gap-2">
        <span className="text-[0.8125rem] font-medium leading-6 text-[--text-color] drop-shadow-[--text-drop-shadow]">
          {children}
        </span>

        {icon && (
          <span className="relative">
            <svg
              viewBox="0 0 10 10"
              className={cx('h-2.5 w-2.5 flex-none group-hover:translate-x-6')}
              aria-hidden
            >
              <path
                fill="#fff"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="m7.25 5-3.5-2.25v4.5L7.25 5Z"
                opacity="0.6"
              />
            </svg>

            <span className="absolute inset-0 flex items-center justify-center">
              <svg
                viewBox="0 0 10 10"
                className={cx(
                  'h-2.5 w-2.5 flex-none -translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100'
                )}
                aria-hidden
              >
                <path
                  fill="#fff"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="m7.25 5-3.5-2.25v4.5L7.25 5Z"
                />
              </svg>
            </span>
          </span>
        )}
      </span>
    </Link>
  );
}
